module.exports = __webpack_public_path__ + "static/media/Close.c2c890f6.svg";